import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PreConclusionDiagnosticPanelComponent } from "./pre-conclusion-diagnostic-panel.component";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material";

@NgModule({
  declarations: [PreConclusionDiagnosticPanelComponent],
  imports: [CommonModule, MatCardModule, MatButtonModule],
  exports: [PreConclusionDiagnosticPanelComponent],
})
export class PreConclusionDiagnosticPanelModule {}
